import { createApi } from '@reduxjs/toolkit/query/react';
import { salaryBaseQuery } from '../../lib/axiosBaseQuery';

export const salaryWalletApi = createApi({
  reducerPath: 'salaryWalletApi',
  baseQuery: salaryBaseQuery,
  tagTypes: ['SalaryWallet', 'SalaryDebitAccounts', 'SalaryDDBanks', 'SalaryWalletTransactions'],
  endpoints: (builder) => ({
    getSalaryDebitAccounts: builder.query<any, void>({
      query: () => ({
        url: 'payment/Wallet/accounts',
        method: 'GET',
      }),
      providesTags: ['SalaryDebitAccounts'],
    }),
    getSalaryDDBanks: builder.query<any, void>({
      query: () => ({
        url: 'payment/Wallet/banks',
        method: 'GET',
      }),
      providesTags: ['SalaryDDBanks'],
    }),
    createSalaryDD: builder.mutation<any, any>({
      query: (data) => ({
        url: 'payment/Wallet/create-direct-debit',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['SalaryDebitAccounts'],
    }),
    getSalaryWallet: builder.query<any, void>({
      query: () => ({
        url: 'payment/Wallet/get-create',
        method: 'GET',
      }),
      providesTags: ['SalaryWallet'],
    }),
    getSalaryFundingAccount: builder.query<any, void>({
      query: () => ({
        url: 'payment/Wallet/funding',
        method: 'GET',
      }),
    }),
    getSalaryWalletTransactionsHistory: builder.query<any, { startDate: string; endDate: string }>({
      query: ({ startDate, endDate }) => ({
        url: 'payment/Wallet/history',
        method: 'GET',
        params: { StartDate: startDate, EndDate: endDate },
      }),
      transformResponse: (response: any) => {
        if (Array.isArray(response?.data)) {
          return { ...response, data: response.data.reverse() };
        }
        return { ...response, data: [] };
      },
      providesTags: ['SalaryWalletTransactions'],
    }),
  }),
});

export const {
  useGetSalaryDebitAccountsQuery,
  useGetSalaryDDBanksQuery,
  useCreateSalaryDDMutation,
  useGetSalaryWalletQuery,
  useGetSalaryFundingAccountQuery,
  useGetSalaryWalletTransactionsHistoryQuery,
} = salaryWalletApi;
